var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "destroy-on-close": true,
      },
      on: { close: _vm.hide },
    },
    [
      !_vm.isInitialized ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.isInitialized
        ? _c(
            "campaign-form",
            _vm._b(
              { on: { stored: _vm.onStored } },
              "campaign-form",
              _vm.formData,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }